/**
 * Copie un ensemble de propriété d'un objet à l'autre
 * Cette fonction est utile pour transférer dynamiquement des données json vers les données d'un composant VueJS
 * Note : Si Src contient des nouvelles propriétés, elles ne sont pas ajoutées à Dest
 */
function copy(Src, Dest){
  for(var key in Dest){
    if (Src[key] != undefined) Dest[key] = Src[key]
  }
}

export default {
  copy
}
